export default {
    ABANDONO: 1,
    OBITO: 2,
    CANCELAMENTO_PELO_AUDITOR: 3,
    VENCIDO: 4,
    CONCLUIDO: 5,
}